export const PROGRAM_SUBSCRIBE_LIST = "programSubscribeList";
export const CHANNEL_FAVORITE_LIST = "channelFavoriteList";
export const APP_MARQUEE_LIST = "appMarqueeList";
export const CHANNEL_COLUMN_INFO = "channelColumnInfo";
export const LAST_ACTIVE_CHANNEL_ID = "lastActiveChannelId";
export const POPUP_WINDOW_LIST = "popupWindowList";
export const LIVE_PLAYER_HEIGHT = "livePlayerHeight";
export const CHANNEL_MARQUEE_LIST = "channelMarqueeList";
export const DYNAMIC_UI_PROPERTIES = "dynamicUiProperties";
export const PAGE_NAV_LIST = "pageNavList";
export const IS_NOVA_TEMPLATE = "isNovaTemplate";
export const EPG_CACHE_LIST = "epgCacheList";
